module.exports = __webpack_public_path__ + "static/img/5-z4.31c6454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-z4.jpg
// module id = 671
// module chunks = 140